import { EntitySelectorsFactory } from "@ngrx/data";
import { ListingHistory } from "./listing-history";
import { createSelector } from "@ngrx/store";
import { selectListingSK } from "../listing-summary.selectors";
import { ListingAudit } from "./listing-audit";

export const listingHistorySelectors = new EntitySelectorsFactory().create<ListingHistory>(
	"ListingHistory"
);

export const selectListingHistories = createSelector(
	selectListingSK,
	listingHistorySelectors.selectEntities,
	(listingSK, listingHistories) =>
		listingHistories.filter((listingHistory) => listingHistory.listingSK === listingSK)
);

export const listingAuditSelectors = new EntitySelectorsFactory().create<ListingAudit>(
	"ListingAudit"
);

export const selectListingAudit = createSelector(
	selectListingSK,
	listingAuditSelectors.selectEntities,
	(listingSK, listingAudits) =>
		listingAudits.filter((listingAudit) => listingAudit.listingSK === listingSK)
);
